/// Datos de Email Body
export const bodyEmail = (destiny, password, platformURL, platformName, userName, platform) => {
  return platform.customEmails
    ? {
        fromEmail: `${platform.fromEmail}`,
        destiny: `${destiny}`,
        subject: `Te dieron de alta en la bolsa de trabajo de ${platformName}`,
        body: `<p style="font-size: 18px;">Hola ${userName},:</p>
        <br />
        <br />
        <p style="font-size: 18px;">Ahora tienes acceso a la bolsa de trabajo de ${platformName} con el 
        correo: <strong>${destiny}</strong> y la contraseña temporal: <strong>${password}</strong></p>
        <br />
        <a styles="font-size: 18px;" href="${platformURL}/company">
            <p style="font-size: 18px;"> Iniciar sesión ahora</p>
        </a>
        <br />
        <p style="font-size: 18px;">Por motivos de seguridad tendrás que actualizar tu contraseña en un link que nosotros te enviaremos.
        Por favor no compartas este correo con nadie e inicia sesión lo antes posible</p>
        <br />
        <br />
        <p style="font-size: 18px;">Saludos, <br />
            El equipo de lapieza.io</p>
        <br />
            <img width="140px" src=${platform.customEmailsLogo} />
           <br />
           ${
             platform.facebookLink &&
             `<a styles="margin: 7px" href=${platform.facebookLink}>
                      <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                     </a>`
           }
           ${
             platform.twitterLink &&
             `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
           }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
            `,
      }
    : {
        destiny: `${destiny}`,
        subject: `Te dieron de alta en la bolsa de trabajo de ${platformName}`,
        body: `<p style="font-size: 18px;">Hola ${userName},:</p>
        <br />
        <br />
        <p style="font-size: 18px;">Ahora tienes acceso a la bolsa de trabajo de ${platformName} con el 
        correo: <strong>${destiny}</strong> y la contraseña temporal: <strong>${password}</strong></p>
        <br />
        <a styles="font-size: 18px;" href="${platformURL}/company">
            <p style="font-size: 18px;"> Iniciar sesión ahora</p>
        </a>
        <br />
        <p style="font-size: 18px;">Por motivos de seguridad tendrás que actualizar tu contraseña en un link que nosotros te enviaremos.
        Por favor no compartas este correo con nadie e inicia sesión lo antes posible</p>
        <br />
        <br />
        <p style="font-size: 18px;">Saludos, <br />
            El equipo de lapieza.io</p>
        <br />
        <img width="140px" src="https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29" />
        <br />
        <p style="font-size: 14px;">¿Ya nos sigues?</p>
        <br />
        <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
            <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
        </a>
        <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
            <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
        </a>
        <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
            <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
        </a>
        <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
            <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
        </a>`,
      };
};

// Generador de Password
export const PasswordGenerator = (length) => {
  const characters = '$+=?@_1234567890ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz';
  let password = '';
  for (let i = 0; i < length; i++) password += characters.charAt(Math.floor(Math.random() * characters.length));
  return password;
};

export default null;
